import Vue from "vue";
import App from "./App.vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import router from "@/router";
import store from "@/store";
import "@/assets/css/normalize.css";
import "@/assets/css/quill.snow.css";
import http from "@/api/api";
import uploadImg from "@/utils/uploadImg";
import VueClipboard from "vue-clipboard2";
// import AmapVue from '@amap/amap-vue'
import scroll from "vue-seamless-scroll";

// AmapVue.config.key = '8be50badefeb1c2ecb2356e589bd1f5f'
// Vue.use(AmapVue)
Vue.use(VueClipboard);
Vue.use(ElementUI);
Vue.use(scroll);

ElementUI.Dialog.props.closeOnClickModal.default = false;

Vue.config.productionTip = false;
Vue.prototype.$store = store;
Vue.prototype.$http = http;
Vue.prototype.$uploadImg = uploadImg;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
